// extracted by mini-css-extract-plugin
export var loadingSpinner = "_redotech-redo-web-src-loading-redo-animation-loading-spinner";
export var spinnerContainer = "_redotech-redo-web-src-loading-redo-animation-spinner-container";